import React from 'react';

// Brand kit artwork: full iCompaas.com logo (outlined text, never retype the
// wordmark), or the icon alone when showText is false.
function Logo({ className = '', showText = true, size = 'md' }) {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-9',
    lg: 'h-12',
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={showText ? '/icompaas-logo-for-light-backgrounds.svg' : '/ic-logo-3.svg'}
        alt="iCompaas"
        className={sizeClasses[size]}
      />
    </div>
  );
}

export default Logo;
